import { createQueryKeys } from '../../factories';

export const SECODA_QUERY_NAMESPACE = ['query', 'queries'];

export const secodaQueryQueryKeyFactory = createQueryKeys(
	SECODA_QUERY_NAMESPACE
);

export const DIALECTS = [
	'sql',
	'bigquery',
	'postgresql',
	'redshift',
	'spark',
	'mariadb',
	'mysql',
	'tsql',
	'db2',
	'hive',
	'n1ql',
	'plsql',
] as const;
